/** Desktop notification tray (browser permission required). */

export type DesktopNotificationPermission = NotificationPermission | 'unsupported'

export function readDesktopNotificationPermission(): DesktopNotificationPermission {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported'
  return Notification.permission
}

/** Shows the browser prompt only when the person has not answered yet. */
export async function requestDesktopNotificationPermission(): Promise<DesktopNotificationPermission> {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported'
  if (Notification.permission !== 'default') return Notification.permission
  try {
    return await Notification.requestPermission()
  } catch {
    return Notification.permission
  }
}

export function showDesktopNotification(input: {
  title: string
  body?: string
  tag?: string
  onClick?: () => void
}): void {
  if (readDesktopNotificationPermission() !== 'granted') return
  try {
    const os = new Notification(input.title, {
      ...(input.body !== undefined ? { body: input.body } : {}),
      ...(input.tag !== undefined ? { tag: input.tag } : {}),
      requireInteraction: true,
    })
    os.onclick = () => {
      window.focus()
      os.close()
      input.onClick?.()
    }
  } catch {
    // The browser refused the popup.
  }
}

export async function tryBrowserNotification(title: string, body: string): Promise<void> {
  await requestDesktopNotificationPermission()
  showDesktopNotification({ title, body })
}
